import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "16px 20px",
  backgroundColor: "#f8f9fa",
  borderRadius: 8,
  border: "1px solid #e0e0e0",
  marginTop: 20,

  [theme.down("sm")]: {
    flexDirection: "column",
    gap: 8,
    padding: "12px 16px",
  },
}));

export const Icon = styled("span")(({ theme }) => ({
  fontSize: 24,

  [theme.down("sm")]: {
    fontSize: 20,
  },
}));

export const Text = styled("span")(({ theme }) => ({
  fontSize: 13,
  color: "#555",
  fontWeight: 500,

  [theme.down("sm")]: {
    fontSize: 12,
    textAlign: "center",
  },
}));

export const BadgesList = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 8,
}));

export const Badge = styled("span")(({ theme }) => ({
  padding: "4px 12px",
  backgroundColor: "#fff",
  border: "1px solid #4caf50",
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 600,
  color: "#4caf50",
  textTransform: "uppercase",

  [theme.down("sm")]: {
    padding: "3px 10px",
    fontSize: 10,
  },
}));

